"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledContainer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _constant = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constant2 = require("./constant");

var _GalleryCard = require("./GalleryCard.proptypes");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var ContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "GalleryCard__ContainerWrapper",
  componentId: "sc-7aocnq-0"
})(["", ";height:", ";grid-column:", ";-ms-grid-column-span:", ";outline:none !important;scroll-snap-align:start;&:focus-within{border:", ";}box-sizing:border-box;", " ", ";"], function (_ref) {
  var columnSpan = _ref.columnSpan;
  return columnSpan && "display: grid";
}, function (_ref2) {
  var columnSpan = _ref2.columnSpan;
  return columnSpan ? "100%" : "100%";
}, function (_ref3) {
  var columnSpan = _ref3.columnSpan;
  return "span ".concat(columnSpan, ";");
}, function (_ref4) {
  var columnSpan = _ref4.columnSpan;
  return columnSpan;
}, function (_ref5) {
  var theme = _ref5.theme,
      focusEffect = _ref5.focusEffect;
  return focusEffect && "1px solid  ".concat(theme.colors.secondaryDark);
}, function (_ref6) {
  var isIE = _ref6.isIE,
      gridCol = _ref6.gridCol;
  return isIE && (0, _styledComponents.css)(["display:-ms-grid;-ms-grid-column:", ";"], gridCol);
}, function (_ref7) {
  var width = _ref7.width;
  return width && "width: ".concat(width, "\n   ");
});

var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "GalleryCard__StyledContainer",
  componentId: "sc-7aocnq-1"
})(["margin:", ";", ";box-sizing:border-box;", ";background-color:", ";", " ", ""], function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.tiny;
}, function (_ref9) {
  var columnSpan = _ref9.columnSpan;
  return columnSpan ? "height: auto" : "height: 100%";
}, function (props) {
  return props.height ? "height: ".concat(props.height) : "max-height: 100%";
}, function (_ref10) {
  var theme = _ref10.theme,
      color = _ref10.color;
  return color ? theme.colors[color] : theme.colors.default;
}, function (_ref11) {
  var hoverEffect = _ref11.hoverEffect;
  return hoverEffect && (0, _styledComponents.css)(["&:hover{box-shadow:0px 4px 8px rgba(0,0,0,0.12);}"]);
}, function (_ref12) {
  var theme = _ref12.theme,
      isIE = _ref12.isIE,
      cardOffsetWidth = _ref12.cardOffsetWidth,
      cardOffsetHeight = _ref12.cardOffsetHeight;
  return isIE && (0, _styledComponents.css)(["width:calc(", "px - ", ");height:calc(", "px - ", ");"], cardOffsetWidth, theme.space.small, cardOffsetHeight, theme.space.small);
});

exports.StyledContainer = StyledContainer;

var GalleryCardWrapper = _styledComponents.default.div.withConfig({
  displayName: "GalleryCard__GalleryCardWrapper",
  componentId: "sc-7aocnq-2"
})(["cursor:pointer;background-color:", ";outline:0 !important;height:100%;display:flex;flex-direction:column;"], function (_ref13) {
  var color = _ref13.color,
      theme = _ref13.theme;
  return color && theme.colors[color] || theme.colors.default;
});

var StyledCardHeader = _styledComponents.default.div.withConfig({
  displayName: "GalleryCard__StyledCardHeader",
  componentId: "sc-7aocnq-3"
})(["position:relative;overflow:hidden;height:100%;"]);

var LabelContainer = _styledComponents.default.div.withConfig({
  displayName: "GalleryCard__LabelContainer",
  componentId: "sc-7aocnq-4"
})(["z-index:2;position:absolute;margin:", " ", " word-break:break-all;"], function (_ref14) {
  var type = _ref14.type,
      theme = _ref14.theme;
  return type === 'primary' ? "0px 8px 4px 8px;" : "".concat(theme.space.tiny, ";");
}, function (_ref15) {
  var type = _ref15.type;
  return type === 'primary' ? "bottom: 28px;" : "bottom:0px; left:0px;";
});

var IconContainer = _styledComponents.default.span.withConfig({
  displayName: "GalleryCard__IconContainer",
  componentId: "sc-7aocnq-5"
})(["margin-right:4px;"]);

var ImageOverlayContainer = _styledComponents.default.div.withConfig({
  displayName: "GalleryCard__ImageOverlayContainer",
  componentId: "sc-7aocnq-6"
})(["width:100%;position:absolute;display:block;left:0;bottom:0;", " ", " ", " ", ""], function (props) {
  return props.overlayHeight ? (0, _styledComponents.css)(["height:", ";"], props.overlayHeight) : "\n        height: 50%;\n      ";
}, function (props) {
  return props.overlayBackground ? (0, _styledComponents.css)(["background:", ";"], props.overlayBackground) : "\n        background: linear-gradient(0deg, #000000 4.3%, rgba(0, 0, 0, 0) 96.12%);\n      ";
}, function (props) {
  return props.overlayZIndex ? (0, _styledComponents.css)(["z-index:", ";"], props.overlayZIndex) : "\n      z-index: 1;\n    ";
}, function (props) {
  return props.borderRadius ? (0, _styledComponents.css)(["border-radius:", ";"], props.borderRadius) : "\n        \n      ";
});

var TextColumnStyleContainer = _styledComponents.default.div.withConfig({
  displayName: "GalleryCard__TextColumnStyleContainer",
  componentId: "sc-7aocnq-7"
})(["display:inline-flex;position:absolute;bottom:0px;padding:26px 16px;width:100%;box-sizing:border-box;"]);

var PrimaryTextColumnStyleContainer = _styledComponents.default.div.withConfig({
  displayName: "GalleryCard__PrimaryTextColumnStyleContainer",
  componentId: "sc-7aocnq-8"
})(["flex-grow:2;z-index:2;"]);

var SecondaryTextColumnStyleContainer = _styledComponents.default.div.withConfig({
  displayName: "GalleryCard__SecondaryTextColumnStyleContainer",
  componentId: "sc-7aocnq-9"
})(["z-index:2;text-align:right;"]);

var GalleryCard = function GalleryCard(props) {
  var index = props.index,
      data = props.data,
      theme = props.theme,
      accessible = props.accessible,
      width = props.width,
      hoverEffect = props.hoverEffect,
      focusEffect = props.focusEffect,
      imageHoverAnimation = props.imageHoverAnimation,
      handleClick = props.handleClick,
      fireGtm = props.fireGtm,
      columnSpan = props.columnSpan,
      isIE = props.isIE,
      cardWidth = props.cardWidth,
      idConfig = props.idConfig,
      enableProgressiveImageLoading = props.enableProgressiveImageLoading,
      lazyLoadImage = props.lazyLoadImage,
      hasOverlay = props.hasOverlay,
      customOverlayProperties = props.customOverlayProperties,
      borderRadius = props.borderRadius,
      icon = props.icon,
      iconSize = props.iconSize,
      color = props.color,
      textLimit = props.textLimit,
      titleTextType = props.titleTextType,
      subtitleTextType = props.subtitleTextType,
      textDisplayStyle = props.textDisplayStyle;

  var _ref16 = idConfig || {},
      widgetName = _ref16.widgetName,
      parentName = _ref16.parentName;

  var _useState = (0, _react.useState)('galleryCard'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dynamicID = _useState2[0],
      setId = _useState2[1];

  (0, _react.useEffect)(function () {
    var url = 'galleryCard';

    if (parentName) {
      url = "".concat(parentName, "-galleryCard");
    }

    if (index) {
      url += "-".concat(index);
    }

    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }

    setId(url);
  }, [widgetName, parentName, index]);
  var gtmEventData = props.gtmEventData;

  var _ref17 = data || {},
      url = _ref17.url,
      image = _ref17.image,
      title = _ref17.title,
      subtitle = _ref17.subtitle,
      newTab = _ref17.newTab,
      lowResolutionImageUrl = _ref17.lowResolutionImageUrl;

  var containerWrapperRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      cardOffsetWidth = _useState4[0],
      setCardOffsetWidth = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      cardOffsetHeight = _useState6[0],
      setCardOffsetHeight = _useState6[1];

  function handleOnClick(e) {
    if (!handleClick && url) {
      gtmEventData = gtmEventData ? gtmEventData.replace('{{productid}}', data.productID || null).replace('{{cardtitle}}', data.title || null).replace('{{redirecturl}}', data.url.includes('airasiago') ? 'external' : 'internal') : null; // eslint-disable-next-line radix

      gtmEventData = gtmEventData ? gtmEventData.replace('{{cardposition}}', parseInt(index) + 1 || null) : null; // eslint-disable-next-line no-unused-expressions

      fireGtm ? fireGtm(gtmEventData, true) : null;
      if (e.target && e.target.getAttribute('id') === 'cta_link') return null;
      return newTab === 'TRUE' || newTab === '' ? window.open(url, '_blank') : window.open(url, '_self');
    }

    return handleClick && handleClick(e);
  }

  var tabIndex = !accessible ? '-1' : '0';
  var dataExists = data && Object.keys(data).length !== 0;
  var isEmpty = data && Object.values(data).every(function (x) {
    return x === null || x === '';
  });
  var intIndex = parseInt(index);
  var intColSpan = parseInt(columnSpan);
  var gridCol = intIndex * intColSpan;
  gridCol += 1;
  var minHeight = _constant2.DEFAULT_CARD_HEIGHT;
  var imageBorderRadius = borderRadius || _constant2.DEFAULT_BORDER_RADIUS;
  var textColor = color || _constant2.DEFAULT_TEXT_COLOR;
  var limit = textLimit || _constant2.DEFAULT_TEXT_LIMIT;
  var primaryTextSize = titleTextType || _constant2.TEXT_TYPE.titleNormal.type;
  var secondaryTextSize = subtitleTextType || _constant2.TEXT_TYPE.titleNormal.type;
  var defaultIconSize = iconSize || _constant2.DEFAULT_ICON_SIZE;

  var overlayprops = _objectSpread({
    borderRadius: borderRadius
  }, customOverlayProperties);

  (0, _react.useEffect)(function () {
    if (dataExists && !isEmpty && isIE) {
      setCardOffsetWidth(cardWidth);
      setCardOffsetHeight(containerWrapperRef.current.offsetHeight);
    }
  }, [cardWidth, dataExists, isEmpty, isIE]);

  function renderTextColumnStyle() {
    return /*#__PURE__*/_react.default.createElement(TextColumnStyleContainer, null, title && /*#__PURE__*/_react.default.createElement(PrimaryTextColumnStyleContainer, {
      type: "primary"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      accessible: false,
      color: textColor,
      textLimit: limit,
      type: primaryTextSize
    }, title)), subtitle && /*#__PURE__*/_react.default.createElement(SecondaryTextColumnStyleContainer, {
      type: "secondary"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      accessible: false,
      color: textColor,
      type: secondaryTextSize
    }, icon && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      icon: icon,
      color: textColor,
      textLimit: limit,
      fontsize: secondaryTextSize
    })), subtitle)));
  }

  function renderTextRowStyle() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(LabelContainer, {
      type: "primary"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      accessible: false,
      color: textColor,
      textLimit: limit,
      type: primaryTextSize
    }, title)), subtitle && /*#__PURE__*/_react.default.createElement(LabelContainer, {
      type: "secondary"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      accessible: false,
      color: textColor,
      type: secondaryTextSize
    }, icon && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      icon: icon,
      color: textColor,
      textLimit: limit,
      fontsize: defaultIconSize
    })), subtitle)));
  }

  return dataExists && !isEmpty ? /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ContainerWrapper, {
    ref: containerWrapperRef,
    isIE: isIE,
    columnSpan: columnSpan,
    width: width,
    focusEffect: focusEffect,
    gridCol: gridCol
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, {
    hoverEffect: hoverEffect,
    isIE: isIE,
    cardOffsetHeight: cardOffsetHeight,
    cardOffsetWidth: cardOffsetWidth,
    columnSpan: columnSpan
  }, /*#__PURE__*/_react.default.createElement(GalleryCardWrapper, {
    id: dynamicID,
    tabIndex: tabIndex,
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, function () {
        return handleOnClick(e);
      }, _constant.KEY_CODE.ENTER);
    },
    onClick: function onClick(e) {
      return handleOnClick(e);
    },
    color: color,
    role: "link",
    "aria-label": "".concat(title, " ").concat(subtitle)
  }, /*#__PURE__*/_react.default.createElement(StyledCardHeader, null, hasOverlay && /*#__PURE__*/_react.default.createElement(ImageOverlayContainer, overlayprops), /*#__PURE__*/_react.default.createElement(_Image.default, {
    lowResolutionImageUrl: lowResolutionImageUrl,
    enableProgressiveImageLoading: enableProgressiveImageLoading,
    hoverAnimation: imageHoverAnimation,
    src: image,
    lazyLoadImage: lazyLoadImage,
    height: minHeight,
    width: _constant2.TOKENS.DEFAULT_IMAGE_WIDTH,
    radius: imageBorderRadius,
    theme: theme,
    accessible: false,
    placeHolderBackground: _constant2.DEFAULT_PLACE_HOLDER_BACKGROUND
  }), textDisplayStyle === _constant2.TEXT_DISPLAY_FORMAT[1] ? renderTextColumnStyle() : renderTextRowStyle()))))) : null;
};

GalleryCard.propTypes = _GalleryCard.GalleryCardPropTypes.PropTypes;
GalleryCard.defaultProps = _GalleryCard.GalleryCardPropTypes.DefaultProps;
var _default = GalleryCard;
exports.default = _default;